<template>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar   color="primary " dark>
              <v-toolbar-title>
               Trekking Request Detail
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-chip color="primary" v-if="trekkingData.statusCode==2" text-color="white">Approved</v-chip>
              <v-chip color="primary darken-1" v-if="trekkingData.statusCode==47" text-color="white">Verified</v-chip>
              <v-chip color="red" v-else text-color="white">Pending</v-chip>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap v-if="trekkingData.trekkingRoute">
                <confirmation-header-text class="ml-2" icon="mdi-alpha-t-box"
                                          text="Trekking Route"></confirmation-header-text>
<!--                <v-flex sm3 xs12>-->
<!--                  <list-item-detail :sub_title="trekkingData.trekkingAgency.name" title="Agency Name">-->
<!--                  </list-item-detail>-->
<!--                </v-flex>-->
                <v-flex sm3 xs12>
                  <list-item-detail :sub_title="trekkingData.trekkingRoute.name" title="Trekking Route">
                  </list-item-detail>
                </v-flex>
                <v-flex sm3 v-if="trekkingData.no_of_days" xs12>
                  <list-item-detail :sub_title="trekkingData.no_of_days" title="Number Of Days">
                  </list-item-detail>
                </v-flex>
                <v-flex sm3 v-if="trekkingData.starting_date" xs12>
                  <list-item-detail :sub_title="trekkingData.starting_date" title="Starting Date">
                  </list-item-detail>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

                <confirmation-header-text class="ml-2" icon="mdi-account"
                                          text="Trekker's Info:"></confirmation-header-text>

                <v-flex class="pt-0" xs12>
                  <v-simple-table class="mx-4" light>
                    <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Country</th>
                      <th class="text-left">Passport number</th>
                      <th class="text-left">Validity</th>
                      <th class="text-left">Visa Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="item.passport_number" v-for="item in trekkingData.trekkers">
                      <td>{{ item.name }}</td>
                      <td>{{ item.country }}</td>
                      <td>{{ item.passport_number }}</td>
                      <td>{{ item.validity }}</td>
                      <td>{{ item.visa ?'Approved':'Unapproved' }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-flex>
                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

                <confirmation-header-text class="ml-2" icon="mdi-account"
                                          text="Nepali Guide Info:"></confirmation-header-text>
                <template v-for="guide in trekkingData.guides">
                  <v-flex :key="'g'+guide.id" sm3 xs12>
                    <list-item-detail :sub_title="guide.name" title="Full Name">
                    </list-item-detail>
                  </v-flex>
                  <v-flex :key="'g1'+guide.id" sm3 xs12>
                    <list-item-detail :sub_title="guide.mobile_number" title="Mobile Number">
                    </list-item-detail>
                  </v-flex>
                  <v-flex :key="'g2'+guide.id" sm3 xs12>
                    <list-item-detail :sub_title="guide.citizenship_number" title="Citizenship No">
                    </list-item-detail>
                  </v-flex>
                  <v-flex :key="'g4'+guide.id" sm3 xs12>

                    <v-list-item-subtitle style="font-size: 12px; user-select: text;">Insurance File
                    </v-list-item-subtitle>
                    <file-display v-if="guide.insurance_file"
                                           :src="guide.insurance_file"
                                           sub_title="Insurance File">
                    </file-display>

                  </v-flex>
                </template>

                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

                <confirmation-header-text class="ml-2" icon="mdi-account"
                                          text="Porter's Info:"></confirmation-header-text>
                <template v-for="(porter) in trekkingData.porters">
                  <v-flex :key="'p'+porter.id" sm3 xs12>
                    <list-item-detail :sub_title="porter.name" title="Full Name:">
                    </list-item-detail>
                  </v-flex>
                  <v-flex :key="'p1'+porter.id" sm3 xs12>
                    <list-item-detail :sub_title="porter.mobile_number" title="Mobile Number:">
                    </list-item-detail>
                  </v-flex>
                  <v-flex :key="'p2'+porter.id" sm3 xs12>
                    <list-item-detail :sub_title="porter.citizenship_number" title="Citizenship No:">
                    </list-item-detail>
                  </v-flex>

                  <v-flex :key="'p4'+porter.id" sm3 xs12>
                    <v-list-item-subtitle style="font-size: 12px; user-select: text;">Insurance File
                    </v-list-item-subtitle>
                    <file-display
                            :src="porter.insurance_file"
                            sub_title="Insurance File">
                    </file-display>
                  </v-flex>
                </template>

                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

                <confirmation-header-text class="ml-2" icon="mdi-alpha-p-box"
                                          text="Payment Info:"></confirmation-header-text>
                <v-flex class="mb-2" v-if="trekkingData.total_cost" xs3>
                  <list-item-detail :sub_title="trekkingData.total_cost"
                                    title="Charge For Trekking Permit(NPR)">
                  </list-item-detail>
                </v-flex>
                <v-flex sm2 lg2>
                  <v-chip
                    color="primary"
                    v-if="trekkingData.payment_status==1"
                    text-color="white"
                  >Paid</v-chip>
                  <v-chip
                    color="red"
                    v-else-if="trekkingData.payment_status==0"
                    text-color="white"
                  >Un-paid</v-chip>
                </v-flex>
                <v-flex sm12 lg12 v-if="trekkingData.payment_status==1">
                  <v-layout row wrap>
                    <v-flex sm4 lg4>
                      <list-item-detail :sub_title="trekkingData.payment_channel"
                                        title="Payment Channel">
                      </list-item-detail>
                    </v-flex>
                    <v-flex sm4 lg4>
                      <list-item-detail title="Payment Reference Id" :sub_title="trekkingData.payment_reference_id"></list-item-detail>
                    </v-flex>
                    <v-flex sm4 lg4>
                      <v-list v-if="trekkingData.payment_proof">
                        <v-list-item href="#">
                          <v-list-item-content>
                            <v-btn
                              no-caps
                              color="info"
                              :href="trekkingData.payment_proof"
                              target="_blank"
                            >
                              <v-icon left>mdi mdi-attachment</v-icon>Payment Proof
                            </v-btn>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<style scoped>

.v-btn--floating.v-btn--small .v-icon {
  line-height: -moz-block-height;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import ListItemDetail from '../../components/ListItemDetail';
import ConfirmationHeaderText from '../../components/ConfirmationHeaderText'
import FileDisplay from "../../components/FileDisplay";
export default {
  components: {FileDisplay, ListItemDetail, ConfirmationHeaderText},
  props: {
    id: String
  },
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData", "loading"]),

  },
  methods: {
    ...mapActions("TrekkingSingle", [
      "resetState",
      "getTrekkingRequestDetail",
      "updatePaymentStatus"
    ]),
  },
  watch: {
    "$route.params.type": function() {
      this.getTrekkingRequestDetail(this.id);
    }
  },
  mounted() {
    this.getTrekkingRequestDetail(this.id);
  },
  destroyed() {
    this.resetState();
  }
};
</script>
